// Shared logout guard, readable from both React code (hooks/components) and
// plain modules (the axios interceptor) without a circular import through the
// Redux store. Prevents a token refresh that was already in flight from
// silently re-authenticating a tab right after it logged out (manual, idle,
// or forced) — see useLogout.js and services/api.js.
let loggedOut = false;

export function markLoggedOut() {
  loggedOut = true;
}

export function isLoggedOut() {
  return loggedOut;
}

export function resetLoggedOutGuard() {
  loggedOut = false;
}
